var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconBubblechat = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.77096 10.0434C5.28739 10.0434 4.89453 9.65056 4.89453 9.16699C4.89453 8.68485 5.28739 8.29199 5.77096 8.29199C6.25453 8.29199 6.64739 8.68485 6.64739 9.16699C6.64739 9.65056 6.25453 10.0434 5.77096 10.0434ZM9.1781 10.0434C8.69453 10.0434 8.30167 9.65056 8.30167 9.16699C8.30167 8.68485 8.69453 8.29199 9.1781 8.29199C9.66167 8.29199 10.0545 8.68485 10.0545 9.16699C10.0545 9.65056 9.66167 10.0434 9.1781 10.0434ZM11.7089 9.16699C11.7089 9.65056 12.1017 10.0434 12.5853 10.0434C13.0689 10.0434 13.4617 9.65056 13.4617 9.16699C13.4617 8.68485 13.0689 8.29199 12.5853 8.29199C12.1017 8.29199 11.7089 8.68485 11.7089 9.16699Z",
    fill: "#606474"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.015 1.5C4.6575 1.5 1.5 5.05959 1.5 9.01127C1.5 10.2732 1.8675 11.5719 2.5125 12.7586C2.6325 12.9547 2.6475 13.2018 2.565 13.4354L2.0625 15.1179C1.95 15.5235 2.295 15.8232 2.6775 15.7031L4.1925 15.2531C4.605 15.1179 4.9275 15.2899 5.31 15.5235C6.405 16.1688 7.77 16.5 9 16.5C12.72 16.5 16.5 13.6232 16.5 8.98873C16.5 4.99199 13.275 1.5 9.015 1.5Z",
    stroke: "#606474",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconBubblechat, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-bubblechat.d9eb80d9.svg";
export { ForwardRef as ReactComponent };